import * as React from "react";
import { AxisType, AxisMode } from "./interfaces/axis";
import Xaxis from "./Xaxis";
import Yaxis from "./Yaxis";
import Y2axis from "./Y2axis";
import * as d3 from "./assets/d3";
import { mjd2unix } from "./helpers/timeParser";
export const GraphAxis = React.memo(function GraphAxis({ axis, scale, dimensions: { width, height }, margins, labelWidth, labelHeight = 11, }) {
    const tickFormat = axis.mode === AxisMode.Date
        ? customTimeFormat
        : AxisMode.Logarithmic
            ? d3.format(".8~g")
            : undefined;
    const graphWidth = width - margins.left - margins.right;
    const graphHeight = height - margins.top - margins.bottom;
    return (React.createElement(React.Fragment, null, axis.type === AxisType.x ? (React.createElement(Xaxis, { scale: scale, height: graphHeight, margins: margins, width: graphWidth, tickFormat: tickFormat, title: axis.title, labelWidth: labelWidth, color: axis.color })) : axis.type === AxisType.y ? (React.createElement(Yaxis, { scale: scale, margins: margins, width: graphWidth, tickFormat: tickFormat, height: graphHeight, title: axis.title, color: axis.color, labelHeight: labelHeight })) : (React.createElement(Y2axis, { scale: scale, margins: margins, width: graphWidth, tickFormat: tickFormat, height: graphHeight, title: axis.title, color: axis.color, labelHeight: labelHeight }))));
});
const formatMillisecond = d3.utcFormat("%Y-%m-%d %H:%M:%S.%L");
const formatSecond = d3.utcFormat("%Y-%m-%d %H:%M:%S");
const formatMinute = d3.utcFormat("%Y-%m-%d %H:%M");
const formatHour = d3.utcFormat("%Y-%m-%d %H");
const formatDay = d3.utcFormat("%Y-%m-%d");
const formatWeek = d3.utcFormat("%Y-%m-%d");
const formatMonth = d3.utcFormat("%Y-%m");
const formatYear = d3.utcFormat("%Y");
export function customTimeFormat(_date) {
    const date = mjd2unix(_date);
    return (d3.timeSecond(date) < date
        ? formatMillisecond
        : d3.timeMinute(date) < date
            ? formatSecond
            : d3.timeHour(date) < date
                ? formatMinute
                : d3.timeDay(date) < date
                    ? formatHour
                    : d3.timeMonth(date) < date
                        ? d3.timeWeek(date) < date
                            ? formatDay
                            : formatWeek
                        : d3.timeYear(date) < date
                            ? formatMonth
                            : formatYear)(date);
}
//# sourceMappingURL=GraphAxis.js.map